import { useQuery, QueryFunction } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'
import { EventRatingsResponse } from './types'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

interface UseEventRatingsParams {
  eventId: string
  limit?: number
  offset?: number
}

export const useEventRatings = ({
  eventId,
  limit = 20,
  offset = 0,
}: UseEventRatingsParams) => {
  const fetchWithAuth = useFetchWithAuth()

  const getEventRatings: QueryFunction<EventRatingsResponse> = async () => {
    if (!eventId) {
      throw new Error('Event ID is required to fetch ratings')
    }

    const params = new URLSearchParams({
      limit: limit.toString(),
      offset: offset.toString(),
    })

    const response = await fetchWithAuth(
      `${URL}/events/${eventId}/ratings?${params}`,
      {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      }
    )

    return response
  }

  return useQuery({
    queryKey: ['eventRatings', eventId, limit, offset] as const,
    queryFn: getEventRatings,
    retry: false,
    staleTime: 5 * 60 * 1000,
    enabled: !!eventId && eventId.length > 0,
  })
}
